import { render, staticRenderFns } from "./PortfolioStats.vue?vue&type=template&id=7fafd8f1&"
import script from "./PortfolioStats.vue?vue&type=script&lang=js&"
export * from "./PortfolioStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports